'use strict';

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PERCENT_PATTERN = /%[0-9]+/g;

module.exports = function (message, args) {
  var _this = this;

  if (!(0, _isString2.default)(message)) {
    return message;
  }

  var percents = 0;
  var output = message.replace(PERCENT_PATTERN, function (matched) {
    percents = matched.substring(1);
    var arg = args[percents - 1];

    if ((0, _isObject2.default)(arg)) {
      return _this.format(arg);
    }

    return arg;
  });
  args.splice(0, percents);
  return output;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vZm9ybWF0TWVzc2FnZS5qcyJdLCJuYW1lcyI6WyJQRVJDRU5UX1BBVFRFUk4iLCJtb2R1bGUiLCJleHBvcnRzIiwibWVzc2FnZSIsImFyZ3MiLCJwZXJjZW50cyIsIm91dHB1dCIsInJlcGxhY2UiLCJtYXRjaGVkIiwic3Vic3RyaW5nIiwiYXJnIiwiZm9ybWF0Iiwic3BsaWNlIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7QUFHQSxJQUFNQSxrQkFBa0IsVUFBeEI7O0FBRUFDLE9BQU9DLE9BQVAsR0FBaUIsVUFBVUMsT0FBVixFQUFtQkMsSUFBbkIsRUFBMEI7QUFBQTs7QUFFMUMsTUFBSyxDQUFDLHdCQUFZRCxPQUFaLENBQU4sRUFBOEI7QUFFN0IsV0FBT0EsT0FBUDtBQUVBOztBQUVELE1BQUlFLFdBQVcsQ0FBZjtBQUVBLE1BQUlDLFNBQVNILFFBQVFJLE9BQVIsQ0FBaUJQLGVBQWpCLEVBQWtDLG1CQUFXO0FBRXpESyxlQUFXRyxRQUFRQyxTQUFSLENBQW1CLENBQW5CLENBQVg7QUFDQSxRQUFJQyxNQUFNTixLQUFNQyxXQUFXLENBQWpCLENBQVY7O0FBQ0EsUUFBSyx3QkFBWUssR0FBWixDQUFMLEVBQXlCO0FBRXhCLGFBQU8sTUFBS0MsTUFBTCxDQUFhRCxHQUFiLENBQVA7QUFFQTs7QUFDRCxXQUFPQSxHQUFQO0FBRUEsR0FYWSxDQUFiO0FBYUFOLE9BQUtRLE1BQUwsQ0FBYSxDQUFiLEVBQWdCUCxRQUFoQjtBQUNBLFNBQU9DLE1BQVA7QUFFQSxDQTFCRCIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxuaW1wb3J0IF8gZnJvbSAnbG9kYXNoJztcbmNvbnN0IFBFUkNFTlRfUEFUVEVSTiA9IC8lWzAtOV0rL2c7XG5cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24oIG1lc3NhZ2UsIGFyZ3MgKSB7XG5cblx0aWYgKCAhXy5pc1N0cmluZyggbWVzc2FnZSApICkge1xuXG5cdFx0cmV0dXJuIG1lc3NhZ2U7XG5cblx0fVxuXG5cdHZhciBwZXJjZW50cyA9IDA7XG5cblx0dmFyIG91dHB1dCA9IG1lc3NhZ2UucmVwbGFjZSggUEVSQ0VOVF9QQVRURVJOLCBtYXRjaGVkID0+IHtcblxuXHRcdHBlcmNlbnRzID0gbWF0Y2hlZC5zdWJzdHJpbmcoIDEgKTtcblx0XHR2YXIgYXJnID0gYXJnc1sgcGVyY2VudHMgLSAxIF07XG5cdFx0aWYgKCBfLmlzT2JqZWN0KCBhcmcgKSApIHtcblxuXHRcdFx0cmV0dXJuIHRoaXMuZm9ybWF0KCBhcmcgKTtcblxuXHRcdH1cblx0XHRyZXR1cm4gYXJnO1xuXG5cdH0gKTtcblxuXHRhcmdzLnNwbGljZSggMCwgcGVyY2VudHMgKTtcblx0cmV0dXJuIG91dHB1dDtcblxufTsiXX0=